// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"82086c472920ad0047c7","339":"cd727afb548a22ea8f11"}[chunkId] + ".js";
};